// CustomSelect.jsx
import React, { useState } from 'react';

export const DEFAULT_SELECT_PLACEHOLDER = 'Choose the Right Option';

const CustomSelect = ({ disabled, label, options, onChange, value, name, placeholder = DEFAULT_SELECT_PLACEHOLDER, error, id, style, required = false, emptyText }) => {
  const [isOpen, setIsOpen] = useState(false);

  // A saved value that is no longer in the list is still shown rather than
  // silently replaced, and an empty value keeps the placeholder selected
  // instead of the browser showing the first option as if it were chosen.
  const hasValue = value !== undefined && value !== null && value !== '';
  const list = Array.isArray(options) ? options : [];
  const shownOptions = hasValue && !list.includes(value) ? [...list, value] : list;

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (event) => {
    const optionValue = event.target.value; // Extract the value from event.target
    onChange({ target: { name, value: optionValue, id: id } }); // Send the updated value to the parent component
    setIsOpen(false);
  };

  return (
    <div className="mt-2 w-full">
      {label && (
        <label
          htmlFor={id}
          className="block mb-1 text-xs md:text-sm font-medium text-gray-700"
        >
          {label}
        </label>
      )}

      <select
        id={id}
        name={name}
        value={hasValue ? value : ''}
        required={required}
        disabled={disabled}
        style={style}
        onChange={handleOptionClick}
        className={`
      w-full appearance-none
      rounded-md border px-3 py-2
      text-xs md:text-sm text-gray-800
      bg-white
      border-gray-300
      focus:outline-none
      focus:ring-2 focus:ring-primary-400
      focus:border-primary-400
      transition
      ${disabled ? "bg-gray-100 cursor-not-allowed" : ""}
      ${error ? "border-red-400 focus:ring-red-300" : ""}
    `}
      >
        <option value="" disabled>
          {placeholder}
        </option>

        {shownOptions.map((item, index) => (
          <option key={index} value={item}>
            {item}
          </option>
        ))}
      </select>

      {emptyText && list.length === 0 && (
        <span className="mt-1 block text-xs text-gray-500">{emptyText}</span>
      )}

      {error && (
        <span className="mt-1 block text-xs text-red-500">
          {error}
        </span>
      )}
    </div>

  );
};


export const CustomSelectForPrescrption = ({
  disabled,
  label,
  options,
  onChange,
  value,
  name,
  placeholder = DEFAULT_SELECT_PLACEHOLDER,
  error,
  id,
  style,
  required = false,
  className = '',
  selectClassName = '',
}) => {
  const handleOptionClick = (event) => {
    const optionValue = event.target.value;
    onChange({ target: { name, value: optionValue, id: id } });
  };

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label
          htmlFor={id}
          className="block mb-1 text-xs font-semibold text-slate-600"
        >
          {label}
        </label>
      )}

      <div className="relative w-full">
        <select
          id={id}
          name={name}
          value={value || ''}
          required={required}
          disabled={disabled}
          style={style}
          onChange={handleOptionClick}
          className={`
            w-full appearance-none
            rounded-xl border border-slate-200 hover:border-slate-300
            bg-white
            pl-3 pr-8 py-1.5
            text-xs font-medium text-slate-800
            focus:outline-none
            focus:ring-2 focus:ring-sky-500/20
            focus:border-sky-500
            transition shadow-sm
            ${disabled ? 'bg-slate-100 text-slate-400 cursor-not-allowed' : ''}
            ${error ? 'border-rose-400 focus:ring-rose-200' : ''}
            ${selectClassName}
          `}
        >
          <option value="" disabled hidden>
            {placeholder}
          </option>

          {options?.map((item, index) => (
            <option key={index} value={item}>
              {item}
            </option>
          ))}
        </select>

        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2.5 text-slate-400">
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>

      {error && (
        <span className="mt-1 block text-xs text-rose-500">
          {error}
        </span>
      )}
    </div>
  );
};


export default CustomSelect;
